import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {withSnackbar} from 'notistack';
import {Grid} from "@material-ui/core";

// Example POST method implementation:
async function postData(url = '', data = {}) {
    // Default options are marked with *
    const response = await fetch(url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json'
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
}

class CapoeiraForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: props.autoOpen || false,
            loading: false,
            email: '',
            phone: '',
            kids_feb_13: '',
            kids_feb_14: '',
            kids_feb_16: ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        // If autoOpen prop is set, open the modal
        if (this.props.autoOpen) {
            this.setState({ open: true });
        }
    }

    componentDidUpdate(prevProps) {
        // Handle autoOpen prop changes
        if (this.props.autoOpen !== prevProps.autoOpen) {
            this.setState({ open: this.props.autoOpen });
        }
    }

    handleClose = () => {
        this.setState({ open: false });
        // Notify parent component if callback provided
        if (this.props.onClose) {
            this.props.onClose();
        }
        // Remove query parameter from URL when modal is closed (only if it was opened via query param)
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('form') === 'capoeira') {
            const url = new URL(window.location);
            url.searchParams.delete('form');
            window.history.replaceState({}, '', url);
        }
    }

    handleChange(e) {
        // console.log('setting ' + e.currentTarget.name + ' with ' + e.currentTarget.value);
        this.setState({[e.currentTarget.name]: e.currentTarget.value});
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({loading: true});

        const obj = {
            "email": this.state.email,
            "phone": this.state.phone,
            "kids_feb_13": this.state.kids_feb_13,
            "kids_feb_14": this.state.kids_feb_14,
            "kids_feb_16": this.state.kids_feb_16
        };

        const that = this;
        postData('/api/capoeira/new?_format=json', obj)
            .then(function (response) {
                console.log(response);
                that.props.enqueueSnackbar('Registration received!', {variant: 'success'});
                that.setState({loading: false, open: false});
                // Reset form
                that.setState({
                    email: '',
                    phone: '',
                    kids_feb_13: '',
                    kids_feb_14: '',
                    kids_feb_16: ''
                });
                // Remove query parameter from URL after successful submission
                if (that.props.autoOpen) {
                    const url = new URL(window.location);
                    url.searchParams.delete('form');
                    window.history.replaceState({}, '', url);
                }
            })
            .catch(function (error) {
                console.log(error);
                that.props.enqueueSnackbar(error.message || 'Error submitting registration', {variant: 'error'});
                that.setState({loading: false});
            });

        return false;
    }

    render() {
        const cta = this.props.cta || 'Sign Up';

        if (this.state.open === false && !this.props.autoOpen) {
            return null;
        }

        const hasContact = this.state.email.length > 0 || this.state.phone.length > 0;
        const hasAtLeastOneDay = this.state.kids_feb_13.length > 0 || 
                                  this.state.kids_feb_14.length > 0 || 
                                  this.state.kids_feb_16.length > 0;

        return (
            <Dialog open={this.state.open} onClose={this.handleClose}
                    aria-labelledby="capoeira-form" maxWidth={'md'} fullWidth={true}>

                <form name="capoeira-form" method="POST">
                    <DialogTitle id="capoeira-form">Capoeira Camp Kauai Registration</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} style={{marginTop: 10}}>
                            <Grid item xs={12}>
                                <h3 style={{marginBottom: 20, fontSize: '1.1rem', color: '#555'}}>Contact Information</h3>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Email"
                                    name="email"
                                    type="email"
                                    autoComplete='email'
                                    value={this.state.email}
                                    onChange={this.handleChange}
                                    placeholder="your@email.com"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Phone"
                                    name="phone"
                                    type="tel"
                                    autoComplete='tel'
                                    value={this.state.phone}
                                    onChange={this.handleChange}
                                    placeholder="(415) 555-1234"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <p style={{fontSize: '0.9rem', color: '#666', marginTop: 10}}>
                                    Please provide at least one contact method (email or phone)
                                </p>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} style={{marginTop: 20}}>
                            <Grid item xs={12}>
                                <h3 style={{marginBottom: 20, fontSize: '1.1rem', color: '#555'}}>Number of Kids for Each Day</h3>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="February 13"
                                    name="kids_feb_13"
                                    type="number"
                                    inputProps={{ min: 0, max: 20 }}
                                    value={this.state.kids_feb_13}
                                    onChange={this.handleChange}
                                    placeholder="0"
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="February 14"
                                    name="kids_feb_14"
                                    type="number"
                                    inputProps={{ min: 0, max: 20 }}
                                    value={this.state.kids_feb_14}
                                    onChange={this.handleChange}
                                    placeholder="0"
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="February 16"
                                    name="kids_feb_16"
                                    type="number"
                                    inputProps={{ min: 0, max: 20 }}
                                    value={this.state.kids_feb_16}
                                    onChange={this.handleChange}
                                    placeholder="0"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Cancel
                        </Button>
                        {this.state.loading === true ?
                            <CircularProgress color='secondary'/>
                            :
                            <Button type="submit" onClick={this.handleSubmit} color="primary" variant="contained"
                                    disabled={!hasContact || !hasAtLeastOneDay}>
                                Submit
                            </Button>
                        }
                    </DialogActions>
                </form>

                <img src="/images/axe-on-kauai-1.jpeg" className='img-fluid' alt='chipa'/>
                <img src="/images/axe-on-kauai-2.jpeg" className='img-fluid' alt='chipa'/>

            </Dialog>
        );
    }

}

export default withSnackbar(CapoeiraForm);

